<template>
  <v-container class="d-flex justify-center pa-6">

    <!--    ЗАГРУЗКА -->
    <v-sheet v-if="pending" class="d-flex justify-center align-center" height="400px">
      <v-progress-circular
          model-value="20" size="100" :color="primaryColor" indeterminate>
      </v-progress-circular>
    </v-sheet>

    <!--  ВСЕ ДАННЫЕ ЗАГРУЖЕНЫ       mx-md-6 mx-sm-4 mx-xs-0                  -->
    <v-sheet v-else-if="calendarData">

      <v-window v-model="step" disabled>
        <!--   ШАГ 1 - ВЫБОР -->
        <v-window-item :value="1" disabled width="320px" class="justify-center">

          <v-img src="logo.svg" class="ma-0"></v-img>

          <div class="v-card-title px-0 mx-0">Выберите дату посещения и билеты:</div>

          <v-select :items="dateList" v-model="date" @update:modelValue="updateDate" variant="outlined"
                    class="font-weight-bold px-6"></v-select>

          <v-card v-if="dayTickets && dayTickets.prices" max-width="320px" elevation="0" class="d-flex justify-center">

            <v-card v-for="ticket in dayTickets.prices" :key="ticket.ticket_date" class="my-6" variant="outlined">
              <v-card-title class="text-wrap">{{ ticket.exposition_name }}</v-card-title>
              <v-card-subtitle class="text-wrap"> {{ ticket.exposition_description }} {{
                  ticket.ticket_type_name
                }}
              </v-card-subtitle>
              <v-card-actions class="justify-end">
                <v-card-title>{{ formatMoney(ticket.price) }}</v-card-title>
                <v-btn size="small" variant="tonal" icon="mdi-minus" class="ma-1 text-h6"
                       @click="addTicket(ticket, -1)"
                       v-show="getSelectedTicketCount(ticket)">-
                </v-btn>
                <div class="text-h6"
                     v-show="getSelectedTicketCount(ticket)">
                  {{ getSelectedTicketCount(ticket) }}
                </div>
                <v-btn size="small" variant="tonal" icon="mdi-plus" class="ma-1 text-h6"
                       @click="addTicket(ticket, 1)">+
                </v-btn>
              </v-card-actions>
            </v-card>

          </v-card>

          <!--          ИТОГО И ДАЛЕЕ-->
          <div v-if="getSelectedCount()>0">
            <v-card-title>Итого {{ formatMoney(getSelectedSum()) }} билетов: {{ getSelectedCount() }}</v-card-title>
            <v-btn :color="primaryColor" type="submit" class="font-weight-bold" variant="flat" @click="step=2">Далее
            </v-btn>

          </div>

          <br><br>


        </v-window-item>

        <!--   ШАГ 2 - ВВОД ДАННЫХ КЛИЕНТА-->
        <v-window-item :value="2" disabled>

          <br>
          <v-card-title>Ваши данные <br>для получения билетов</v-card-title>
          <br>
          <br>

          <v-sheet width="320px" class="v-container justify-center align-center align-self-center">
            <v-form @submit.prevent ref="clientForm" class="pa-0">

              <v-text-field
                  v-model="client.name"
                  :rules="nameRules"
                  label="Имя"
                  name="name"
                  type="text"
                  variant="underlined"
              ></v-text-field>

              <v-text-field
                  v-model="client.email"
                  :rules="emailRules"
                  :label="`E-mail для получения билетов`"
                  type="email"
                  name="email"
                  variant="underlined"
              ></v-text-field>

              <v-text-field v-if="1"
                            v-model="client.tel"
                            @change="client.tel = client.tel.replace('+7','')"
                            :rules="telRules"
                            prefix="+7"
                            label="Телефон"
                            type="tel"
                            name="tel"
                            variant="underlined"
              ></v-text-field>

              <v-text-field v-if="0"
                            _type="date"
                            v-model="client.birthDate"
                            :rules="dateRules"
                            @input="onInputBirthDate"
                            label="Дата рождения"
                            variant="underlined"
                            required
              ></v-text-field>

            </v-form>
            <br>
            <v-container class="d-flex justify-space-between">
              <v-btn class="" @click="step=1" variant="tonal">
                Назад
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn :color="primaryColor"
                     _disabled="client.error"
                     type="submit" class="font-weight-bold" variant="flat"
                     @click="onSubmitClientForm()">
                Далее
              </v-btn>
            </v-container>
            <br>
            <v-card-subtitle class="text-wrap justify-end">
              Нажимая «Далее», вы соглашаетесь с
              <a href="https://tickets.crocus-oceanarium.ru/offer" target="_blank" style="color: black"> Условиями
                приобретения и
                Офертой</a>
            </v-card-subtitle>

          </v-sheet>

        </v-window-item>

        <!--   ШАГ 3 - ПОДТВЕРЖДЕНИЕ ЗАКЗА-->
        <v-window-item :value="3" disabled>
          <div class="d-inline-flex">
            <v-sheet width="320px" class="d-flex flex-column align-center">
              <br>
              <v-card-title class="pt-0 pb-0">Подтверждение заказа</v-card-title>

              <v-container class="d-flex flex-column  justify-space-between">

                <v-card-text class="d-flex flex-column justify-start pt-2 pb-0 text-left">
                  <div class="text-subtitle-1 font-weight-bold">{{ this.toUserDate(date) }}</div>
                  <div class="text-caption">Крокус Сити Океанариум</div>
                  <div class="text-caption">66-й км МКАД, Крокус Сити<br>станция метро Мякинино (последний вагон из центра)
                  </div>
                  <br>
                  <div v-if="client.name" class="text-subtitle-1">{{ client.name }}</div>
                  <div v-if="client.birthDate" class="text-subtitle-1">Дата рождения:
                    {{ client.birthDate }}
                  </div>
                  <div v-if="client.tel" class="text-subtitle-1">{{ client.tel }}</div>
                  <div v-if="client.email" class="text-subtitle-1">{{ client.email }}</div>

                </v-card-text>

                <v-expansion-panels>
                  <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-title class="text-body-1 font-weight-bold text-left">
                      Билетов: {{ getTotalCount() }}
                    </v-expansion-panel-title>
                    <template v-if="selectedTickets">
                      <v-expansion-panel-text v-for="(ticket,i) in selectedTickets" :key="i"
                                              class="text-body-2 text-left">
                        {{ ticket.exposition_name }} {{ ticket.ticket_type_name }} x{{ ticket.count }}
                        {{
                          formatMoney(Math.round(ticket.price * ticket.count))
                        }}
                      </v-expansion-panel-text>
                    </template>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-card-text class="text-body-1 font-weight-bold text-no-wrap text-left pt-2 pb-0 mr-0 pr-0">
                  {{ 'Итоговая стоимость:' }} {{
                    formatMoney(getSelectedSum())
                  }}
                </v-card-text>

                <v-dialog
                    v-model="dialogPromo"
                    width="auto"
                >
                  <template v-slot:activator="{ props }">
                    <v-btn
                        v-if="0"
                        v-bind="props" class="my-2" :color="primaryColor" variant="tonal">
                      Ввести промокод %
                    </v-btn>
                  </template>

                  <v-card max-width="400" min-width="320" :loading="dialogPromoPending ? primaryColor : false"
                          :disabled="dialogPromoPending">
                    <v-text-field
                        focused
                        clearable
                        autofocus
                        v-model="promoCode"
                        :error-messages="promoCodeError"
                        label="Промокод"
                        variant="outlined"
                        class="pa-4 pb-0 font-weight-bold"
                        @input="promoCode = promoCode.toUpperCase()"
                        :color="primaryColor"
                    ></v-text-field>
                    <v-card-actions class="justify-center my-2 mx-2">
                      <v-btn @click="dialogPromo = false; promoCode = ''; promoCodeError = ''" variant="tonal">Отмена
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn :color="primaryColor" class="font-weight-bold" @click="applyPromoCode" variant="flat">
                        Применить
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                </v-dialog>

                <v-checkbox v-if="1" v-model="conditionsAgree" class="pa-0 ma-0" hide-details
                            :error="conditionsAlarm && !conditionsAgree" style="opacity: 1;">
                  <template v-slot:label>
                    <div class="text-wrap pl-2 ma-0 text-body-1 text-left">
                      Согласен с <a v-if="eventData?.conditionsUrl" :href="eventData?.conditionsUrl" target="_blank"
                                    style="color: black;">Условиями
                      приобретения и Офертой</a>
                      <span v-else>Условиями приобретения и Офертой</span>
                    </div>

                  </template>
                </v-checkbox>

                <v-btn :color="primaryColor" class="mt-0 mb-2 font-weight-bold" variant="flat"
                       @click="createOrder(false)">
                  {{ getTotalSum() > 0 ? 'Перейти к оплате' : 'Оформить Заказ' }}
                </v-btn>

                <!--                <v-btn v-if="eventData.sbpAvailable" color="" class="my-2 font-weight-bold bg-green-lighten-5"-->
                <!--                       variant="flat"-->
                <!--                       @click="createOrder(true)">-->
                <!--                  Оплатить <img src="sbp_logo2.png" height="32" alt="СБП"/>-->
                <!--                </v-btn>-->

                <!-- Информация о продавце-->
                <v-dialog
                    v-if="1"
                    v-model="dialogSellerInfo"
                    width="auto"
                >
                  <template v-slot:activator="{ props }">
                    <v-card-subtitle v-bind="props" style="cursor: pointer">
                      Информация о продавце
                    </v-card-subtitle>
                  </template>
                  <v-card max-width="340">
                    <v-card-text>{{ legalInfo }}
                    </v-card-text>
                    <v-card-actions class="justify-center">
                      <v-btn variant="tonal" @click="dialogSellerInfo = false">Закрыть</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-btn @click="step=2" class="my-3" variant="tonal">Назад</v-btn>

              </v-container>


            </v-sheet>
          </div>
        </v-window-item>

        <!--    СОЗДАЕМ ЗАКАЗ ОЖИДАНИЕ...   -->
        <v-window-item :value="4" disabled>

          <br>
          <v-card-title>Резервирование...</v-card-title>

          <v-sheet width="320px" class="d-inline-flex flex-column justify-start">
            <v-form>
              <v-progress-circular
                  class="mt-12"
                  model-value="20" size="100" :color="primaryColor" indeterminate>
              </v-progress-circular>
            </v-form>
          </v-sheet>

        </v-window-item>

        <!--      ЗАКАЗ СОЗДАЛСЯ - ПЕРЕД ОТПРАВЛЕНИЕМ НА ОПЛАТУ -->
        <v-window-item :value="5" disabled>
          <!--todo Добавить проверку если заказ оплатился или отменился по API-->
          <v-sheet v-if="orderData" width="320px" class="d-inline-flex flex-column justify-start">
            <br>
            <br>
            <v-card-title>Заказ {{ orderData.pay_order_id }}<br>успешно зарезервирован.</v-card-title>
            <br>
            <v-card-text v-if="0">
              Пожалуйста завершите оплату заказа на странице платежной системы.
            </v-card-text>
            <v-card-title v-if="orderData.paySeconds" :color="orderData.paySeconds < 30 ? 'red' : ''">
              Время резерва {{ formatTimer(orderData.paySeconds) }}
            </v-card-title>
            <br>
            <v-btn :href="orderData.pay_url" target="_blank" class="my-0 font-weight-bold" :color="primaryColor"
                   variant="flat">
              Перейти к оплате
            </v-btn>
            <v-card-text>
              Вы будете перенаправлены на страницу платежной системы:
            </v-card-text>

          </v-sheet>


        </v-window-item>

        <!--      УСПЕШНО -->
        <v-window-item :value="6" disabled>
          <br>
          <br>
          <br>
          <v-icon
              class="mb-5"
              color="success"
              icon="mdi-check-circle"
              size="112"
          />
          <br>
          <v-card-title>Успешная покупка!</v-card-title>

          <!--todo добавить кнопку Изменить почту я ошибся-->
          <v-sheet width="320px" class="d-inline-flex flex-column justify-start">
            <v-form>

              <v-card-text>
                Ваши {{ eventData.ticketNameMany.toLowerCase() }} отправлены на почту {{ client.email }}
              </v-card-text>

              <v-btn @click="close">
                Вернуться
              </v-btn>
              <br>
              <br>
            </v-form>
          </v-sheet>


        </v-window-item>

        <!--      ОШИБКА -->
        <v-window-item :value="7" disabled>
          <br>
          <br>
          <br>

          <v-icon
              class="mb-5"
              color="amber-lighten-3"
              icon="mdi-close-circle-outline"
              size="112"
          />
          <br>
          <v-card-title>Что-то пошло не так</v-card-title>

          <v-sheet width="320px" class="d-inline-flex flex-column justify-start">
            <v-form>

              <v-card-text>
                {{ errorText }}
              </v-card-text>

              <v-btn @click="close">
                Вернуться
              </v-btn>
              <br>
              <br>
              <br>
            </v-form>
          </v-sheet>

        </v-window-item>

      </v-window>

      <!--    ДИАЛОГ ЗАКРЫТИЯ-->
      <v-dialog v-model="closeDialog" width="auto">
        <v-card max-width="340" class="pt-2 px-6 pb-6">
          <v-card-title class="ma-2">Вы точно хотите выйти?</v-card-title>
          <v-btn :color="primaryColor" variant="flat" @click="closeDialog=false" class="font-weight-bold">Продолжить
            покупку
          </v-btn>
          <br>
          <v-btn @click="close" variant="tonal">Выйти</v-btn>
        </v-card>
      </v-dialog>

    </v-sheet>

    <!--  НЕТ ДАННЫХ или ОШИБКА СОЕДИНЕНИЯ -->
    <v-sheet v-else class="ma-16" height="400px">
      <v-card-title class="mx-10">Сервис временно недоступен<br>Попробуйте позже</v-card-title>
      <br>
      <br>
      <v-btn :color="primaryColor" variant="flat" class="font-weight-bold" @click="reloadPage">
        Попробовать снова
      </v-btn>
    </v-sheet>
  </v-container>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-facing-decorator';
import * as API from "@/api";
import {closeWidget, getOriginDomain, redirect} from "@/utils";
import {setAuthLogin} from "@/api";
import {CalendarData, DayTickets, OrderData, SelectedTicket, Ticket} from "@/@types/api";

type ValidateRules = Array<(value: any) => any>

@Component({
  components: {}
})
export default class Home extends Vue {

  legalInfo = 'Организатором (исполнителем услуги) является АО «КРОКУС», ОГРН 1027700257023, место нахождения - 143401, Московская область, Красногорский район, г. Красногорск, ул. Международная, д. 18'

  calendarData?: CalendarData = undefined
  dateList: { value: string, title: string }[] = []
  date = ''
  dayTickets?: DayTickets = undefined
  formattedDate = ''

  closeDialog = false

  close = closeWidget

  //selectedLimit = 10

  orderData: OrderData | null = null
  payRedirectWindow = false // если false значит браузер блокирнул

  primaryColor = 'blue-lighten-1'

  conditionsAgree = false
  conditionsAlarm = false

  // загрузка общая
  pending = true

  dialogEntryTickets = false // если со схемы кликнули на входной сегмент - показать диалог выбора
  dialogEntryTicketsSegment = '' // если указан, фильтруем

  dialogPromo = false
  dialogPromoPending = false
  promoCode = ''
  promoCodeError = ''
  mobile = false

  formatTimer(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    // Форматируем минуты и секунды для отображения в формате 00:00
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  }

  formatMoney(amount, digits = 0) {
    // Преобразуем число в строку и разделяем целую и десятичную части
    let parts = amount.toFixed(digits).toString().split('.');

    // Форматируем целую часть, добавляя разделители тысяч
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u2009');  // 2009 тонкий , u00A0 обычный

    // Возвращаем отформатированную строку
    return parts.join('.') + '\xa0₽';
  }

  async createOrder() {

    if (!this.conditionsAgree) {
      this.conditionsAlarm = true
      return;
    }

    this.step = 4

    API.createOnlineOrder({
      tickets: this.selectedTickets,
      name: this.client.name,
      tel: this.client.tel.trim() ? "7" + this.client.tel.trim() : "",
      email: this.client.email,
      birthDate: this.client.birthDate,
      //sum: this.getTotalSum(),
      //ymClientId: Array.from(window.ymData.ids).join(',') + " " + window.ymData.clientId,
      promoCode: this.promoCode,
      comment: ""
    }, false)
        .then(orderData => {

          this.orderData = orderData

          // для таймера сколько секунд осталось
          if (this.orderData?.paySeconds)
            setInterval(() => {
              if (this.orderData?.paySeconds) {
                this.orderData.paySeconds = this.orderData.paySeconds - 1
                if (this.orderData.paySeconds < 0)
                  this.orderData.paySeconds = 0
              }
            }, 1000)

          if (this.orderData.pay_url == "success") {
            //this.$router.push('/success')
            this.step = 6
          } else {
            this.step = 5

            //this.ymAdd()

            // Если режим админа тогда показываем QR
            // if (this.$route.query['admin'])
            //   this.$router.push(`/qr?url=${encodeURIComponent(orderData.payUrl)}`)
            // // Если клиент, тогда перенаправляем на процессинг
            // else

            // работает - переделали на кнопку и показ таймера
            setTimeout(() => {
              if (this.orderData?.pay_url)
                this.payRedirectWindow = redirect(this.orderData.pay_url)
              if (this.payRedirectWindow)
                this.close()
            }, 100)

          }
          //this.step = 6

        })

        .catch((e) => {

          console.log(e)

          //this.$router.push('/fail?text=' + encodeURIComponent('Нам не удалось сформировать Ваш заказ. Пожалуйста повторите попытку.'))//this.step = 7
          this.showError('Нам не удалось сформировать Ваш заказ. Пожалуйста повторите позже.')


        })


  }

  dialogSellerInfo = false

  dialogPaymentRedirect = true

  getTotalSum = this.getSelectedSum

  getTotalCount = this.getSelectedCount

  onInputBirthDate(event: InputEvent) {

    // прибавили символ
    if (event.data) {
      if (this.client.birthDate.length === 2 || this.client.birthDate.length === 5)
        this.client.birthDate += '.'
      else if (this.client.birthDate.length > 10)
        this.client.birthDate = this.client.birthDate.slice(0, 10)
    }
    // // удалили символ
    else
      this.client.birthDate = ''

  }

  applyPromoCode() {

    return 1

  }

  async onSubmitClientForm() {

    const {valid} = await (this.$refs.clientForm as any).validate()

    if (valid) {
      this.step = 3

      if (this.$route.query['promocode'] as string) {
        this.promoCode = this.$route.query['promocode'] as string
        this.applyPromoCode()
      }

    }

  }

  client = {
    name: '',
    email: '',
    tel: '',
    birthDate: ''
  }

  nameRules: ValidateRules = []

  emailRules: ValidateRules = []

  telRules: ValidateRules = []

  dateRules: ValidateRules = []

  step = 1

  errorText = ''

  showError(text = "") {
    this.errorText = text
    this.step = 7
  }

  updateDate() {
    this.selectedTickets = []
    this.dayTickets = this.calendarData?.find(v => v.date === this.date)
  }

  async created() {

    // можно вынести в App
    // пробуем получить родительский домен...
    //let originDomain = getOriginDomain(this.$route.query)
    setAuthLogin('crocus-oceanarium-qr')

    this.telRules.push(value => {

      if (!value.trim()) return false;
      if (value.trim() && !/^\d+$/.test(value)) return 'Некорректный формат'

      return true

    })
    this.dateRules.push(value => {

      //if (/^\d{11}$/.test(value)) return true
      //this.client.error = !value// !/^\d+$/.test(value)

      if (!value.trim()) return false;

      // 25.12.2023
      if (value.trim() && !value.match(/^(0[1-9]|[12][0-9]|3[01])\.(0[0-9]|1[0-2])\.\d{4}$/)) return 'Некорректная дата'

      return true
    },)

    this.emailRules.push(value => {
      if (!value.trim()) return false;

      if (!/.+@.+\..+/.test(value))
        return 'E-mail некорректный'

      return true
    },)

    this.nameRules.push(value => {
      if (!value.trim()) return false;
      if (!/^[a-zA-Zа-яА-Я\s']+$/.test(value)) return 'Неверные символы'
      if (value?.length > 32) return 'Имя слишком длинное'

      return true
    })

    this.pending = true
    try {
      this.calendarData = await API.getCalendar()
      console.log(this.calendarData)
      this.dateList = this.calendarData.map(v => {
        return {
          value: v.date, title: this.toUserDate(v.date)
        }
      })
      this.date = this.dateList[0]?.value
      this.updateDate()

    } catch (e) {
      this.step = 7

    } finally {
      this.pending = false
    }

  }

  toUserDate(date: string) {
    return (new Date(date)).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long', // "августа" (в родительном падеже)
      year: 'numeric'
    })
  }

  reloadPage() {
    if (typeof window !== 'undefined')
      window.location.reload()

  }

  selectedTickets: SelectedTicket[] = []

  getSelectedTicketCount(ticket: Ticket) {
    let total = 0
    for (const ticketS of this.selectedTickets)
      if (this.isTicketsEqualSelected(ticket, ticketS))
        total += ticketS.count
    return total
  }

  getSelectedCount() {
    let total = 0
    for (const ticket of this.selectedTickets)
      total += ticket.count
    return total
  }

  getSelectedSum() {
    let total = 0
    for (const ticket of this.selectedTickets)
      total += ticket.price * ticket.count
    return total
  }

  isTicketsEqualSelected(ticket: Ticket, ticketS: SelectedTicket): boolean {
    return ticket.exposition_id == ticketS.exposition_id
        && ticket.ticket_type_id == ticketS.ticket_type_id
        && ticket.price == ticketS.price
  }

  addTicket(ticket: Ticket, addCount: number) {

    if (addCount > 0 && this.getTotalCount() > 11) return;

    for (let ticketS of this.selectedTickets) {
      if (this.isTicketsEqualSelected(ticket, ticketS)) {
        ticketS.count += addCount
        if (ticketS.count < 1) ticketS.count = 0
        return;
      }
    }

    // значит в цикл return не сработал добавляем новый элемент
    if (addCount > 0)
      this.selectedTickets.push({
        ...ticket,
        count: addCount,
        date: this.date,
      })

  }

}

</script>

<style>

.v-sheet {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

</style>
